import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FiSearch, FiChevronDown, FiChevronUp } from "react-icons/fi";
import ModalCloseIcon from "../../assets/svg/close-modal.svg";
import { useNavigate } from "react-router-dom";
import { getFAQListApi } from "./common-api";

export default function HelpQuestions() {
  const navigate = useNavigate();
  const [faqList, setFaqList] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    getFAQList();
  }, []);

  const getFAQList = async () => {
    try {
      const response = await getFAQListApi();
      if (response.success === true) {
        setFaqList(
          response.data.map((item) => ({
            ...item,
            expand: false,
          }))
        );
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  return (
    <Container fluid className="main-container" style={{ position: "relative" }}>
      <div
        style={{
          width: "100vw",
          height: "calc(100vh - 80px)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "start",
        }}
      >
        <div className="mt-2" style={{ fontSize: "40px", fontWeight: "600", color: "#172B4D" }}>
          Frequently asked questions
        </div>
        <div className="mt-1" style={{ fontSize: "14px", fontWeight: "400", color: "#172B4D" }}>
          These are the most commonly asked questions about Mawalog suite.
        </div>
        <div style={{ fontSize: "14px", fontWeight: "400", color: "#172B4D" }}>Can’t wait what you’re looking for? Chat with our AI</div>
        <div className="mt-3">
          <div style={{ position: "relative", width: "250px" }}>
            <FiSearch
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#aaa",
                fontSize: "18px",
              }}
            />
            <input
              type="text"
              className="form-control"
              placeholder="Search questions..."
              style={{
                paddingLeft: "35px",
                width: "100%",
                height: "45px",
                borderRadius: "100px",
                border: "2px solid #B8D8FF",
              }}
              onChange={(e) => {
                const value = e.target.value;
                setSearch(value);
              }}
              value={search}
            />
          </div>
        </div>
        <div className="mt-2" style={{ width: "100%", maxWidth: "831px" }}>
          <div style={{ fontSize: "14px", fontWeight: "400", color: "#172B4D" }}>Total questions : {faqList.filter((item) => (search !== "" && item.question?.toLowerCase().includes(search?.toLowerCase())) || (search === "" && item)).length}</div>
          <div className="mt-1" style={{ maxWidth: "831px" }}>
            {faqList
              .filter((item) => (search !== "" && item.question?.toLowerCase().includes(search?.toLowerCase())) || (search === "" && item))
              .map((item, index) => {
                return (
                  <div
                    key={"question" + index}
                    onClick={() => {
                      const tempHelps = [...faqList];
                      const index = tempHelps.findIndex((column) => column.id === item.id);
                      if (index > -1) {
                        tempHelps[index].expand = !tempHelps[index].expand;
                        setFaqList(tempHelps);
                      }
                    }}
                    style={{
                      width: "100%",
                      borderRadius: "16px",
                      background: "#FFFFFF",
                      padding: "18px 20px",
                    }}
                  >
                    <div className="style-justify-between">
                      {" "}
                      <div
                        style={
                          item.expand
                            ? {
                              fontSize: "16px",
                              fontWeight: "700",
                              color: "#2C8C53",
                            }
                            : {
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#172B4D",
                            }
                        }
                      >
                        {item.question}
                      </div>
                      {item.expand ? <FiChevronUp size={20} color="#2C8C53" /> : <FiChevronDown size={20} color="#172B4D" />}
                    </div>
                    {item.expand && <div>{item.answer}</div>}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "20px",
          backgroundColor: "#ffffff",
          borderRadius: "100px",
        }}
      >
        <img
          src={ModalCloseIcon}
          alt="Close"
          onClick={() => {
            navigate(-1);
          }}
          style={{
            cursor: "pointer",
            width: "40px",
            height: "40px",
            borderRadius: "50%",
          }}
        />
      </div>
    </Container>
  );
}
